import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Projects from './Projects';
import AddProjectsForm from './AddProjectForm';

function MyProject() {
  const [cases, setCases] = useState([]);
  const [showAddCaseForm, setShowAddCaseForm] = useState(false);

  // Get the user from localStorage
  const user = JSON.parse(localStorage.getItem("user"));
  const userRole = user?.role || '';

  useEffect(() => {
    getProjects();
  }, []);

  const getProjects = async () => {
    const token = localStorage.getItem("token");

    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/Projects`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      setCases(res.data);
    } catch (err) {
      console.error("Error fetching cases:", err);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6 text-white">Dashboard</h1>

        {/* Show the "Add Project" button only if user is NOT a Developer */}
      {userRole !== 'Developer' && (
        <button
          onClick={() => setShowAddCaseForm(!showAddCaseForm)}
          className="mb-6 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
        >
          {showAddCaseForm ? "Close Form" : "Add project"}
        </button>
      )}

      {showAddCaseForm && userRole !== 'Developer' && (
      
        <AddProjectsForm closeModal={() => setShowAddCaseForm(false)} onProjectAdded={getProjects} />
      )}


      <Projects cases={cases} fetchCases={getProjects}/>
    </div>
  );
}

export default MyProject;
